import { useState, useEffect } from "react";
import { Field, reduxForm } from "redux-form";
import { connect } from "react-redux";
import ReactDOM from "react-dom";
import { Button, Checkbox, Input } from "expano-components";

import { ReactComponent as DangerIcon } from "icons/danger.svg";
import StyledMissingModal from "./styles";

const InputField = (props) => <Input {...props} />;
const CheckField = (props) => <Checkbox {...props} />;

const validate = (values) => {
  const errors = {};
  if (!values.missing_quantity) {
    errors.missing_quantity = "Wymagane";
  } else if (isNaN(Number(values.missing_quantity))) {
    errors.missing_quantity = "Musi być liczbą";
  } else if (Number(values.missing_quantity) < 1) {
    errors.missing_quantity = "Wartość musi być większa od zera";
  }
  if (
    !values.is_reported_product_missing &&
    !values.is_reported_product_broken &&
    !values.is_reported_product_incomplete
  ) {
    errors.is_reported_product_missing =
      "Przynajmniej jedna opcja musi być zaznaczona";
  }
  return errors;
};

let timeout;

const MissingModal = ({
  id,
  handleSubmit,
  handleClose,
  product,
  markAsMissingGdnLine,
  pristine,
}) => {
  const [active, setActive] = useState(false);
  const [is_loading, setLoading] = useState(false);
  useEffect(() => {
    timeout = setTimeout(() => {
      setActive(true);
    }, 200);
    return () => clearTimeout(timeout);
  }, []);

  const onSubmit = async (values) => {
    try {
      setLoading(true);
      await markAsMissingGdnLine({ id, ...values });
      handleClose();
    } finally {
      setLoading(false);
    }
  };

  return ReactDOM.createPortal(
    <StyledMissingModal>
      <div className="popup-wrapper">
        <form
          noValidate
          onSubmit={handleSubmit(onSubmit)}
          className={`popup ${active ? "active" : ""}`}
        >
          <header className="popup__header">
            <DangerIcon />
            <h2 className="dashboard__title heading">Zgłoś brak</h2>
            <Button type="close" onClick={handleClose} />
          </header>
          <div className="popup__body">
            <div className="popup-text">
              <p>
                <strong>Zgłaszasz brak produktu</strong>
              </p>
              <p>{product.sku}</p>
              <p>{product.name}</p>
              <div style={{ maxWidth: 230, marginTop: 30 }}>
                <Field
                  type="number"
                  id="missing_quantity"
                  name="missing_quantity"
                  component={InputField}
                  label="Podaj ilość brakujących produktów"
                />
              </div>
              <p className="m-t-20 text-danger">
                <strong>Jaki jest powód braku produktu?</strong>
              </p>
              <div className="missing-product-checkboxes">
                <Field
                  type="checkbox"
                  id="is_reported_product_missing"
                  name="is_reported_product_missing"
                  component={CheckField}
                  label="Za mało produktów"
                />
                <Field
                  type="checkbox"
                  id="is_reported_product_incomplete"
                  name="is_reported_product_incomplete"
                  component={CheckField}
                  label="Produkt niekompletny"
                />
                <Field
                  type="checkbox"
                  id="is_reported_product_broken"
                  name="is_reported_product_broken"
                  component={CheckField}
                  label="Produkt uszkodzony"
                />
              </div>
            </div>
          </div>
          <div
            className="popup__footer"
            style={{
              padding: "10px 15px",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <Button type="cancel" text="Anuluj" onClick={handleClose} />
            <button
              disabled={pristine || is_loading}
              type="submit"
              onClick={handleSubmit(onSubmit)}
              className="btn btn-sm btn-green"
            >
              <span>{is_loading ? "Proszę czekać..." : "Zgłoś"}</span>
            </button>
          </div>
        </form>
      </div>
    </StyledMissingModal>,
    document.getElementById("root")
  );
};

export default connect(() => ({
  initialValues: {
    missing_quantity: "",
    is_reported_product_missing: false,
    is_reported_product_broken: false,
    is_reported_product_incomplete: false,
  },
}))(
  reduxForm({
    form: "gdn-line-missing",
    validate,
    enableReinitialize: true,
  })(MissingModal)
);
